export const FemaleSpeakers = [
    // { value: "en-US-JennyMultilingualNeural", label: "en-US-JennyMultilingualNeural" },
    // { value: "zh-CN-YunyangNeural", label: "zh-CN-YunyangNeural" },
    // {value:"zh-CN-XiaoxiaoNeural", label:"zh-CN-XiaoxiaoNeural"}
    {value:"en-GB-AdaMultilingualNeural", label:"en-GB-AdaMultilingualNeural"}
]

export default FemaleSpeakers;